/*
 * @Author: CHY
 * @Date: 2022-12-13 14:13:24
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-05-24 10:16:31
 * @FilePath: \liancan-public-screen-school\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/views/index/index.vue";
import IndexScroll from "@/views/index/indexScroll.vue";
import IndexDorm from "@/views/dormitory/index.vue";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Index",
    component: Index
}, {
    path: "/index-scroll",
    name: "IndexScroll",
    component: IndexScroll
}, {
    path: "/index-dorm",
    name: "IndexDorm",
    component: IndexDorm
}];

const router = new VueRouter({
    routes
});

export default router;